import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PointOfSaleRounded } from '@mui/icons-material';

const money = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
});

export default function PaymentPanel({ total, impuestos, onCobrar, disabled }) {
  return (
    <Box sx={{ borderTop: '1px solid #dce5ee', px: 1.35, py: 1.15, bgcolor: '#fff' }}>
      <Box
        sx={{
          border: '1px solid #dce6f0',
          borderRadius: 1.9,
          px: 1.25,
          py: 1,
          mb: 1,
          bgcolor: '#f6f9fd',
        }}
      >
        <Stack direction="row" alignItems="flex-end" justifyContent="space-between" sx={{ gap: 1 }}>
          <Box>
            <Typography variant="body2" color="text.secondary" fontWeight={800}>Impuestos</Typography>
            <Typography variant="body2" fontWeight={900}>{money.format(impuestos)}</Typography>
            <Typography variant="h6" fontWeight={1000} sx={{ lineHeight: 1.05, mt: 0.55, color: '#17263a' }}>
              Total a cobrar
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: { xs: 34, lg: 40 },
              color: '#0874ef',
              fontWeight: 1000,
              letterSpacing: '-.045em',
              lineHeight: 1,
              textAlign: 'right',
            }}
          >
            {money.format(total)}
          </Typography>
        </Stack>
      </Box>

      <Button
        fullWidth
        variant="contained"
        size="large"
        startIcon={<PointOfSaleRounded />}
        disabled={disabled}
        onClick={onCobrar}
        sx={{
          minHeight: 56,
          fontSize: 19,
          fontWeight: 950,
          borderRadius: 1.8,
          bgcolor: '#22a447',
          boxShadow: '0 8px 18px rgba(34,164,71,.22)',
          '&:hover': { bgcolor: '#198b3b', boxShadow: '0 10px 22px rgba(34,164,71,.28)' },
          '&.Mui-disabled': { bgcolor: '#cbd5df', color: '#7b8794' },
        }}
      >
        Cobrar {money.format(total)}
      </Button>
    </Box>
  );
}
